<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-calendar" inline title="View calendar">
          <router-link :to="{ name: 'eventCalendarList' }">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
          </router-link>
        <v-card flat class="px-2">
          <v-row>
            <v-col v-if="this.eventColorID !== 2" cols="12" md="6">
              <label class="font-weight-medium body-2">Title <span class="error--text"></span></label><br />
              <span> {{ title }} </span>
            </v-col>
            <v-col cols="12" md="6">
              <label class="font-weight-medium body-2"> {{ titles }} </label> <br />
              <span> {{ subtitle }} </span>
            </v-col>
            <v-col cols="12" md="8">
              <label class="font-weight-medium body-2"> Description </label>
              <div> {{ discription }} </div>
            </v-col>
            <v-col cols="12" v-if="dropFile1.length > 0">
              <label class="accent--text">Uploaded Documents</label>
              <div class="mt-2" rounded="lg" v-for="(file, i) in dropFile1" :key="i">
                <v-btn elevation="1" class="mr-2" small default @click="download(file.urlPath)">
                  <v-icon left color="primary">mdi-download</v-icon>
                  {{ file.type }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import Utils from '@/utils'
export default {
  name: 'viewCalendar',
  props: ['calendarID'],
  components: {
    MaterialCard
  },
  data () {
    return {
      total: 0,
      dropFile: [],
      discription: '',
      type: '',
      title: '',
      fromDate: '',
      toDate: '',
      subtitle: '',
      typeData: [],
      annonceData: [],
      eventColorID: '',
      hasClicked: false,
      loader: true,
      sendData: {},
      titles: '',
      selectedfranchiseeID: [],
      dropFile1: [],
      documentData: [],
      isWrite: false,
      isLoading: false
    }
  },

  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.calendar()
    await this.announcementDocuments()
  },
  methods: {
    calendar: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/communication/eventCalender/${this.calendarID}`)
        this.annonceData = data

        this.eventColorID = this.annonceData.eventColorID
        this.title = this.annonceData.title
        this.subtitle = this.annonceData.subTitle
        this.discription = this.annonceData.descriptions
        if (this.annonceData.eventColorID === 2) {
          this.titles = 'Any Message'
        } else {
          this.titles = 'Sub Title'
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    announcementDocuments: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/communication/eventCalender/${this.calendarID}`)
        this.documentData = data
        this.dropFile1 = this.documentData.eventDocumentsMaps
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    download: async function (i) {
      try {
        let url = await http.get(`${constants.API_URL}/api/staff/downloadurl?s3urlKey=${i}`)
        window.open(url.data)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    }
  }
}
</script>
